module.exports = __webpack_public_path__ + "media/images/menu/icn-login-9ddfea8d18e926f2ba0744ede5229ef0.svg";